import React from "react";
import { Button, Form, Input, Modal } from "antd";

import styles from "../Ponude.module.scss";

const SendEmailModal = ({
  posaljiPonudu,
  setPosaljiPonudu,
  offer,
  actions,
}) => {
  const [form] = Form.useForm();

  const handeSubmit = ({ email }) => {
    actions.sendOfferToEmail(offer.id, email);
    setPosaljiPonudu(false);
  };

  return (
    <Modal
      className={styles.posaljiPonudu}
      open={posaljiPonudu}
      onCancel={() => setPosaljiPonudu(false)}
    >
      <div className="text-xs font-light italic text-black text-opacity-85 mb-2">
        Upišite email i kliknite na pošalji da bi dostavili ponudu na željenu
        adresu
      </div>
      <Form form={form} name="basic" onFinish={handeSubmit}>
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: "Unesite email!",
            },
            { type: "email" },
          ]}
        >
          <Input type="email" placeholder="email " />
        </Form.Item>
        <Form.Item>
          <Button
            htmlType="submit"
            className="text-sm text-white bg-light-blue font-normal w-[88px] rounded-sm border-light-blue shadow-sm"
          >
            POŠALJI
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SendEmailModal;
